import { ChatContent, ChatMessage } from './PromptChatAdapter';

const widgetKey = (message: ChatMessage, content: ChatContent): string | undefined => {
	const type = content.contentType.trim().toLowerCase();
	if (!message.groupId || !content.widgetId || message.role === 'user' || (type !== 'html' && type !== 'sandboxed-html-v1')) return undefined;
	return JSON.stringify([message.groupId, message.role, message.agentName, content.widgetId]);
};

/** Preserve the append-only history; only suppress superseded HTML parts in the display. */
export function selectLatestChatWidgets(messages: ChatMessage[]): ChatMessage[] {
	const latest = new Map<string, ChatContent>();
	for (const message of messages) {
		for (const content of message.contents ?? []) {
			const key = widgetKey(message, content);
			if (key) latest.set(key, content);
		}
	}
	return messages.flatMap((message) => {
		if (!message.contents) return [message];
		const contents = message.contents.filter((content) => {
			const key = widgetKey(message, content);
			return !key || latest.get(key) === content;
		});
		if (contents.length === message.contents.length) return [message];
		const removedFileIds = new Set(message.contents.filter((content) => !contents.includes(content)).map((content) => content.fileId));
		const attachments = message.attachments?.filter((attachment) => !removedFileIds.has(attachment.fileId));
		if (!contents.length && !attachments?.length) return [];
		return [{ ...message, contents, attachments }];
	});
}
